import axios from "axios";
import { SERVERPATH } from "./index";

export async function preQualify(payload) {
    const response = await axios.post(`${SERVERPATH}/external/prequalification`, payload);

    const { status: responseStatus, data: responseData } = response;

    if (responseStatus !== 200) {
        throw response;
    }

    const { status, data } = responseData;

    if (status !== 200) {
        throw responseData;
    }

    return data;
}

export async function preQualifyRestrictions(payload) {
    const response = await axios.post(`${SERVERPATH}/external/prequal-restrictions/`, payload);

    const { status: responseStatus, data: responseData } = response;

    if (responseStatus !== 200) {
        throw response;
    }

    const { status, data } = responseData;

    if (status !== 200) {
        throw responseData;
    }

    return data;
}
